import { TFunction } from 'i18next';

import { getHomePageTitle } from '~/modules/home/constants';

import {
  HOME_PAGE_V2_AI_DETECTOR_PATH,
  HOME_PAGE_V2_CHAT_PATH,
  HOME_PAGE_V2_HOME_PATH,
  HOME_PAGE_V2_HUMANIZER_PATH,
  HOME_PAGE_V2_PLAGIARISM_PATH,
} from './constants';
import { HomePageV2SidebarNavigationEntry } from './types';

export const getHomePageV2SidebarNavigationEntries = (
  t: TFunction,
): ReadonlyArray<HomePageV2SidebarNavigationEntry> => [
  {
    label: getHomePageTitle(t),
    icon: 'general/home/24',
    path: HOME_PAGE_V2_HOME_PATH,
    sideMenuButton: 'home',
  },
  {
    label: t('home:v2.sidebar.ai_detect', 'AI Detect'),
    icon: 'general/ai-detector/24',
    path: HOME_PAGE_V2_AI_DETECTOR_PATH,
    sideMenuButton: 'ai_content_detector',
  },
  {
    label: t('home:v2.sidebar.humanize', 'Humanize'),
    icon: 'general/humanize/24',
    path: HOME_PAGE_V2_HUMANIZER_PATH,
    sideMenuButton: 'ai_text_humanizer',
  },
  {
    label: t('home:v2.sidebar.plagiarism_check', 'Plagiarism Check'),
    icon: 'general/plagiarism/24',
    path: HOME_PAGE_V2_PLAGIARISM_PATH,
    sideMenuButton: 'plagiarism_checker',
  },
  {
    label: t('home:v2.sidebar.chat_with_ai', 'Chat with AI'),
    icon: 'general/reprism-chat/24',
    path: HOME_PAGE_V2_CHAT_PATH,
    sideMenuButton: 'ai_chat',
  },
];
